<template>
  <v-overlay
    :model-value="newVersionAvailable"
    class="align-center justify-center"
    persistent>
    <v-alert
      class="bg-accent"
      elevation="4"
      rounded="xl"
      height="72"
      @update:model-value="newVersionAvailable = $event">
      <div class="d-flex align-center">
        <div class="mr-4">
          An update is available. Please refresh to download the latest version.
        </div>
        <v-btn
          variant="elevated"
          size="small"
          color="primary"
          rounded
          @click="refresh">
          Refresh Now
        </v-btn>
      </div>
    </v-alert>
  </v-overlay>
</template>

<script>
import { versionCheckerMixin } from "@/mixins/VersionChecker";

export default {
  name: "NewVersion",
  mixins: [versionCheckerMixin],
  data: () => ({
    environment: process.env.NODE_ENV,
  }),
  mounted() {
    if (this.environment === "development") return;
    this.initVersionCheck();
  },
  methods: {
    refresh() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.v-alert {
  bottom: 15px;
  right: 15px;
  z-index: 2000;
}
</style>
